export const SET_EVENTS = 'SET_EVENTS';
export const SET_ACTIVE_EVENT = 'SET_ACTIVE_EVENT';
export const SET_UNSAVED_DATA = 'SET_UNSAVED_DATA';
export const SET_VALIDATION = 'SET_VALIDATION';
export const SET_EVENT_HAS_ERRORS = 'SET_EVENT_HAS_ERRORS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_EVENT_LOADING = 'SET_EVENT_LOADING';

// initial state
const state = {
  isLoading: false,
  list: {},
  active: {},
  pagination: {},
  unsavedData: false,
  validation: {},
  eventHasErrors: false
}

// getters
const getters = {
  events: state => state.list,
  isLoading: state => state.isLoading,
  eventPagination: state => state.pagination,
  event: state => state.active,
  unsavedData: state => state.unsavedData,
  validation: state => state.validation,
  eventHasErrors: state => state.eventHasErrors,
}

// actions
const actions = {
  getMyEvents: ({ commit }, payload) => {
    axios.get(laroute.route('api.events.mine', payload))
      .then((response) => {
        commit(SET_EVENTS, {
          events: response.data.data
        });

        if (response.data.meta) {
          commit(SET_PAGINATION, {
            pagination: response.data.meta
          });
        }
      })
  },

  getArchiveEvents: ({ commit }) => {
    axios.get(laroute.route('api.events.archived'))
      .then((response) => {
        commit(SET_EVENTS, {
          events: response.data.data
        });

        if (response.data.meta) {
          commit(SET_PAGINATION, {
            pagination: response.data.meta
          });
        }
      })
  },

  getMoreEvents: ({ commit }, payload) => {

    axios.get(laroute.route('api.events.mine', payload))
      .then((response) => {
        commit(SET_EVENTS, {
          events: response.data.data
        });

        commit(SET_PAGINATION, {
          pagination: response.data.meta
        });

      })
  },

  setEventPagination: ({ commit }, payload) => {
    commit(SET_PAGINATION, {
      pagination: payload
    });
  },

  getEvent: ({ commit }, payload) => {
    axios.get(laroute.route('api.events.show', { event: payload.id }))
      .then((response) => {
        commit(SET_ACTIVE_EVENT, {
          event: response.data.data
        });
      })
  },

  setValidation: ({ commit }, event) => {

    let route = laroute.route('api.event.validation')

    axios.post(route, event)
      .then((response) => {
        commit(SET_VALIDATION, {
          validation: response.data
        });
      })
  },

  setActiveEvent: ({ commit }, payload) => {
    commit(SET_ACTIVE_EVENT, {
      event: payload.data
    });
  },

  setUnsavedData: ({ commit }, payload) => {
    commit(SET_UNSAVED_DATA, {
      data: payload
    });
  },

  setEventIsLoading: ({ commit }, payload) => {
    commit(SET_EVENT_LOADING, {
      isLoading: payload
    });
  },

  setEventHasErrors: ({ commit }, payload) => {
    commit(SET_EVENT_HAS_ERRORS, {
      errors: payload
    });
  },
}

// mutations
const mutations = {
  [SET_EVENTS]: (state, payload) => {
    if (Array.isArray(payload.events)) {
      state.list = {};
    }

    state.list = Object.assign({}, state.list, payload.events);
  },

  [SET_PAGINATION]: (state, payload) => {
    state.pagination = Object.assign({}, state.pagination, payload.pagination);
  },

  [SET_EVENT_LOADING]: (state, payload) => {
    state.isLoading = payload.isLoading
  },

  [SET_ACTIVE_EVENT]: (state, payload) => {
    state.active = Object.assign({}, state.active, payload.event);
  },

  [SET_UNSAVED_DATA]: (state, payload) => {
    state.unsavedData = payload.data;
  },

  [SET_VALIDATION]: (state, payload) => {
    state.validation = payload.validation;
  },

  [SET_EVENT_HAS_ERRORS]: (state, payload) => {
    state.eventHasErrors = payload.errors;
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
